import React from 'react';
import {observer} from 'mobx-react';
import Subnav from 'main/containers/benefits/components/Subnav';
import BenefitEnrolmentList from './BenefitEnrolmentList';

const BenefitEnrolmentDirectory = observer(({scope}) => {
  return (
    <div>
      <Subnav scope={scope}/>
      <BenefitEnrolmentList/>
    </div>
  );
});

export default BenefitEnrolmentDirectory;
